import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashedLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 630,
	height: 1,
	viewBox: "0 0 630 1",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("line", {
		y1: .5,
		x2: 630,
		y2: .5,
		stroke: "#E5E5E5",
		strokeDasharray: "8 8"
	})
});
export default SvgDashedLine;
